<template>
  <div class="send-mail-wrapper">
    <div class="popup">
      <div class="popup-header">
        <div class="title-text">영수증 받기</div>
      </div>
      <div class="content">
        <div class="mail-form">
          <div class="form-title">
            <div class="label">입력하신 이메일로 영수증을 보내드립니다.</div>
          </div>
          <div class="form-content">
            <input type="text" placeholder="example@baemin.com" v-model="email" />
            <p v-show="false">이메일을 다시 입력하세요.</p>
            <p v-show="false">이메일을 정확히 입력해주세요.</p>
            <p class="invalid-email-info" v-show="isInvalidEmail">이메일을 정확히 입력해주세요.</p>
          </div>
          <div class="note">
            배달의민족은 상품판매의 당사자가 아니며 상품판매와 관련한 일체의 책임은 각 업소에게
            있습니다. 배달의민족 서비스는 결제정보의 중개 또는 통신판매중개시스템의 제공만을
            대상으로 하고 배달의민족 서비스의 이용자와 업소 간의 거래관계, 구매내용 및 업소에 게재된
            상품정보, 거래조건 등에 대해서는 어떠한 보증이나 책임도 부담하지 않으며 상품의 광고,
            주문 배송 및 환불 등과 관련한 의무와 책임은 각 업소에 있습니다.
          </div>
          <div class="send-btn" @click="sendReceipt">{{ getBtnText() }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendReceipt',
  data() {
    return {
      paymentKey: null,
      email: '',
      loading: false,
      emailSent: false,
      isInvalidEmail: false
    }
  },
  methods: {
    sendReceipt() {
      if (!this.validEmail(this.email)) {
        this.isInvalidEmail = true
        return
      }
      if (this.loading) {
        return
      }
      this.loading = true
      this.$http
        .post('/v1/payment/approval/receipt/send', {
          paymentKey: this.paymentKey,
          customerEmail: this.email
        })
        .then(
          response => {
            this.isInvalidEmail = false
            this.emailSent = true
            this.loading = false
            this.$store.dispatch('toast/open', {
              text: '입력하신 이메일로 영수증이 발송되었습니다'
            })
          },
          error => {
            this.isInvalidEmail = false
            this.loading = false
            this.$store.dispatch('toast/open', {
              text: '영수증 발송에 실패했습니다.\n잠시 후 다시 시도해주세요.'
            })
          }
        )
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    getBtnText() {
      if (this.loading) {
        return '발송중'
      }
      if (this.emailSent) {
        return '다시 보내기'
      }
      return '보내기'
    }
  },
  created() {
    this.paymentKey = this.$route.params.paymentKey
  }
}
</script>

<style scoped>
.invalid-email-info {
  color: #f30000;
}

.send-mail-wrapper {
  background-color: #ffffff;
  padding: 24px 0;
}

.popup {
}

.popup-header {
  display: flex;
  justify-content: center;
}

.title-text {
  font-size: 18px;
  text-align: center;
  color: #030303;
}

.content {
  padding: 16px;
}

.mail-form {
}

.form-title {
  font-size: 16px;
  text-align: left;
}

.label {
  font-size: 16px;
  letter-spacing: -0.5px;
}

.form-content {
  margin: 0px;
  margin-top: 18px;
}

.note {
  text-align: left;
  color: #888888;
  font-size: 12px;
  padding: 16px 0;
}

input {
  border: solid 1px #dddddd;
  height: 50px;
  width: 100%;
  font-size: 16px;
  text-align: left;
  color: #000000;
}

.send-btn {
  width: 100%;
  height: 50px;
  background-color: #2ac1bc;
  font-size: 20px;
  text-align: center;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
